<template>
	<StandardModal
		open
		:title="$t('admin_groups_manage_permissions_button')"
		:confirmText="$t('common_button_save')"
		:confirmProps="{ disabled, loading }"
		@confirm="save"
		@cancel="close"
		ref="modal"
		class="permissions-modal"
	>
		<div class="modal-wrapper">
			<FormItem v-for="f in visibleFields" :label="$t(f.label)" :key="f.field">
				<Dropdown :options="options" v-model="settings[f.field]" />
			</FormItem>
		</div>
	</StandardModal>
</template>

<script>
import { StandardModal, FormItem, Dropdown } from '@/components/common'
import { patch } from '../common'

const fields = [
	{ field: 'changetitle', label: 'groupsettings_permissions_changeTitle' },
	{
		field: 'changecategory',
		label: 'groupsettings_permissions_changeCategory',
	},
	{ field: 'addmember', label: 'groupsettings_permissions_addMember' },
	{ field: 'removemember', label: 'groupsettings_permissions_removeMember' },
	{ field: 'leavegroup', label: 'groupsettings_permissions_leaveGroup' },
	{
		field: 'create_videosession',
		label: 'groupsettings_permissions_create_videosession',
	},
	{
		field: 'videosessionrecordcloud',
		label: 'groupsettings_permissions_videoSessionRecordCloud',
	},
	{
		field: 'create_message',
		label: 'groupsettings_permissions_create_message',
	},
	{
		field: 'assign_task',
		label: 'groupsettings_permissions_assign_task',
	},
	{
		field: 'create_announcement',
		label: 'groupsettings_permissions_create_announcement',
	},
]

export default {
	name: 'PermissionsModal',
	components: { StandardModal, FormItem, Dropdown },
	props: { group: Object },
	data() {
		return { settings: [], fields, loading: false }
	},
	emits: ['success', 'close'],
	mounted() {
		this.copySettings()
	},
	methods: {
		async save() {
			this.loading = true
			try {
				const group = await patch(
					`/organization/groups/${this.group.id}`,
					this.settings
				)
				this.$emit('success', group)
				this.$alert.success(
					this.$t('admin_people_changes_saved_confirmation_label')
				)
				this.close()
			} catch (e) {
				this.loading = false
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.title = null
			this.$emit('close')
		},
		copySettings() {
			this.settings = this.visibleFields.reduce((acc, f) => {
				acc[f.field] = this.group[f.field]
				return acc
			}, {})
		},
	},
	computed: {
		options() {
			return [
				{
					id: 'owner',
					label: this.$t('groupsettings_permissions_owners'),
				},
				{
					id: 'member',
					label: this.$t('groupsettings_permissions_everyone'),
				},
			]
		},
		visibleFields() {
			if (!this.group) return []
			return fields.filter((f) =>
				f.field.includes('_')
					? this.group[`grant_${f.field}`]
					: this.group[`grant${f.field}`]
			)
		},
		disabled() {
			return this.visibleFields.every(
				(f) => this.settings[f.field] === this.group[f.field]
			)
		},
	},
	watch: {
		group(group) {
			if (!group) return
			this.copySettings()
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.permissions-modal {
	.modal-wrapper {
		padding: 24px 35px;
		.form-item {
			margin-bottom: 24px;
			.dropdown-selected {
				background: #fafafa;
			}
		}
	}
}
</style>
